import { render, staticRenderFns } from "./AgentsSlider.vue?vue&type=template&id=3071ca5b&scoped=true&"
import script from "./AgentsSlider.vue?vue&type=script&lang=js&"
export * from "./AgentsSlider.vue?vue&type=script&lang=js&"
import style0 from "./AgentsSlider.vue?vue&type=style&index=0&id=3071ca5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071ca5b",
  null
  
)

export default component.exports